import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import {Column, Row} from "simple-flexbox";
import {css, StyleSheet} from "aphrodite";
import SelectComponent from "../../components/form/SelectComponent";
import LabelInputVerticalComponent from "../../components/global-components/LabelInputVerticalComponent";
import Button from "@material-ui/core/Button";
import {DateRangePicker} from "react-dates";
import "../../assets/css/customDateRangePicker.css"
import {
    getProvinceList,
    getProvinceListError,
    getProvinceListPending
} from "../../reducers/master-data/province_reducer";
import {connect} from "react-redux";
import {provinceList} from "../../actions/master-data/province_action";
import {withRouter} from "react-router-dom";
import moment from "moment";
import { getCityList } from "../../reducers/master-data/city_reducer";
import { listCity } from "../../actions/master-data/city_action";


class ModalFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            province: {
                label: "SEMUA PROVINSI",
                value: "",
            },
            city: {
                label: "SEMUA KOTA/KABUPATEN",
                value: "",
            },
            startDate: null,
            endDate: null,
        }
        this.handleChangeProvince = this.handleChangeProvince.bind(this);
        this.handleChangeCity = this.handleChangeCity.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleReset = this.handleReset.bind(this);
    }


    handleChangeProvince(e) {
        if (e) {
            this.setState({
                province: {
                    label: e.label,
                    value: e.value,
                }
            });
            this.props.listCity({province_id: e.value})
        } else {
            this.setState({ province: "" });
        }
    }

    handleChangeCity(e) {
        if (e) {
            this.setState({
                city: {
                    label: e.label,
                    value: e.value,
                }
            });
        } else {
            this.setState({ city: "" });
        }
    }

    componentDidMount() {
        const {provinceList, listCity} = this.props;

        provinceList({ length: 10 });
        listCity({length: 10})
    }

    handleSubmit(){
        const { onHide, handleRefresh} = this.props;
        const { province, city, startDate, endDate} = this.state;
        const param = {
            province: province.value,
            city: city.value,
            published_start_date: startDate ? moment(startDate).format("YYYY-MM-DD") : "",
            published_end_date: endDate ? moment(endDate).format("YYYY-MM-DD") : "",
        }
        handleRefresh(param);
        onHide()
    };

    handleReset(){
        this.setState({
            province: {
                label: "SEMUA PROVINSI",
                value: "",
            },
            city: {
                label: "SEMUA KOTA/KABUPATEN",
                value: "",
            },
            startDate: null,
            endDate: null,
        })
    }

    render() {
        const { show, onHide } = this.props;
        const { province, city } = this.state;
        let provinceOption = [],
            cityOptions = [];
        const { provinceList_data, listCity_data } = this.props;

        if(listCity_data && listCity_data.data.length !== 0){
            cityOptions = listCity_data.data.map((item) => ({
                label: item.name,
                value: item.city_id,
            }));
            cityOptions = [
                {label: "SEMUA KOTA/KABUPATEN", value: "", },
                ...cityOptions,
            ]
        }
        if (provinceList_data) {
            provinceOption = provinceList_data.map((value, index) => {
                return {value: value.province_id, label: value.name};
            });
            provinceOption = [
                {label: "SEMUA PROVINSI", value: "", },
                ...provinceOption,
            ]
        }
        return (
            <Modal
                show={show}
                onHide={onHide}
                dialogClassName="modal-width"
                aria-labelledby="contained-modal-title-vcenter"
                style={{borderRadius: 20}}
            >
                <Modal.Header closeButton>
                    <p style={{ fontSize: 20, fontWeight: 600 }}>Filter</p>
                </Modal.Header>
                <Modal.Body>
                    <Column className={css(styles.bodyModal)}>
                        <LabelInputVerticalComponent label="Provinsi" marginTop="20px">
                            <SelectComponent
                                isClearable={false}
                                placeholder="Pilih provinsi"
                                options={provinceOption}
                                onChange={this.handleChangeProvince}
                                asyncUrl="master_data/data_reference/find_province"
                                isAsync
                                value={province}
                                id="province"
                            />
                        </LabelInputVerticalComponent>
                        <LabelInputVerticalComponent label="Kota/Kabupaten" marginTop="20px">
                            <SelectComponent
                                isClearable={false}
                                placeholder="Pilih kota/kabupaten"
                                options={cityOptions}
                                asyncUrl="master_data/data_reference/find_city"
                                onChange={this.handleChangeCity}
                                isAsync
                                value={city}
                                id="city"
                            />
                        </LabelInputVerticalComponent>
                        <LabelInputVerticalComponent label="Tanggal Posting" marginTop="20px">
                            <DateRangePicker
                                startDate={this.state.startDate}
                                startDateId="reg_id"
                                endDate={this.state.endDate}
                                endDateId="reg_id"
                                onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
                                focusedInput={this.state.focusedInput}
                                onFocusChange={focusedInput => this.setState({ focusedInput })}
                                isOutsideRange={() => false}
                                showDefaultInputIcon
                                inputIconPosition="before"
                                showClearDates
                                small
                                block
                                numberOfMonths={1} autoFocus
                                minimumNights={0}
                            />
                        </LabelInputVerticalComponent>

                        <Row
                            horizontal="space-between"
                            vertical="center"
                            className={css(styles.footerModal)}
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                className={css(styles.rejectButton)}
                                onClick={this.handleReset}
                            >
                                RESET
                            </Button>
                            <Button
                                variant="contained"
                                color="secondary"
                                className={css(styles.approveButton)}
                                onClick={this.handleSubmit}
                            >
                                APPLY
                            </Button>
                        </Row>
                    </Column>
                </Modal.Body>
            </Modal>
        );
    }
}

const styles = StyleSheet.create({
    bodyModal: {
        paddingLeft: 40,
        paddingRight: 40,
    },
    labelMargin: {
        marginTop: 10,
        marginBottom: 10,
    },
    approveButton: {
        background: "#2CB96A 0% 0% no-repeat padding-box",
        boxShadow: "none",
        width: "100%",
    },
    rejectButton: {
        background: "#EAEBED 0% 0% no-repeat padding-box",
        marginRight: 10,
        color: "#00B559",
        backgroundColor: "#FFFFF",
        borderColor: "#00B559",
        boxShadow: "none",
        width: "100%",
    },
    footerModal: {
        marginTop: 20,
        height: 80,
        width: "100%",
    },
});


function mapStateToProps({  provinceList, listCity }) {
    return {
        provinceList_pending: getProvinceListPending(provinceList),
        provinceList_data: getProvinceList(provinceList),
        provinceList_error: getProvinceListError(provinceList),
        listCity_data: getCityList(listCity),
    };
}

export default connect(mapStateToProps, {
    provinceList,
    listCity
})(withRouter(ModalFilter));
